<template>
  <div class="scrollable">
    <div class="scroll-sidebar">
      <div class="px-3">
        <div class="m-3">
          <span class="filter-label-sidebar">{{ $t('laboratory.sidebar.setup') }}</span>
        </div>
        <div
          v-for="section in sections"
          :key="section.id"
          v-testing="section.code"
          class="section-card mb-3 p-3"
          :class="{'active':section.checked}"
          @click="sectionChanged(section)"
        >
          <span>{{ section.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SectionsSidebarTracking',
    props: {
        sections: { type: Array, required: true }
    },
    methods: {
        sectionChanged(section) {
            section.checked = !section.checked

            this.$emit('sectionChanged', section)
        }
    }
}
</script>

<style scoped lang="scss">

    .sidebar__tracking .section-card {
        border: 1px solid #d8d8d8;
        border-radius: 0.25rem;
        cursor: pointer;
    }

    .sidebar__tracking .section-card.active {
        border: 1px solid vt-color(primary);
        background: vt-color(primary);
    }

    .sidebar__tracking .section-card.active span {
        color: vt-color(white-light);
    }

    .sidebar__tracking .section-card span {
        color: vt-color(white-light);
    }

    /*--Active elements--*/

    .elements {
        transition: 0.3s;
    }

    .elements.active {
        background: vt-color(light-primary);
    }

    .elements.active span {
        color: vt-color(primary);
    }

    .elements .circle {
        transition: 0.3s;
    }

    /*--Circle states--*/

    .elements .circle.pending {
        border-color: #fc6274;
        color: #fc6274;
    }

    /*-- General--*/

    .scroll-sidebar {
        overflow-y: auto;
        height: calc(100vh - 95px);
    }

    .section .section-btn,
    .section .section-btn:active {
        border-radius: 0;
        background: vt-color(base-text);
        border: transparent;
        border-bottom: 1px solid #d8d8d8;
        color: vt-color(white-light);
        text-align: left;
        font-size: 1rem;
    }

    .section .section-btn i {
        font-size: 1.2rem;
    }

    .section .section-content .elements .element-btn {
        background: transparent;
        border-radius: 0;
        border: none;
        color: #707070;
    }

    .section .section-content {
        position: relative;
    }

    .section .section-content .line {
        background: #cccccc;
        width: 3px;
        height: 10px;
        position: absolute;
        left: 35px;
        top: 10px;
    }

    .element-btn .circle {
        border: 2px solid vt-color(primary);
        background: #fff;
        color: vt-color(primary);
        border-radius: 50%;
        width: 38px;
        height: 38px;
        font-size: 15px;
        z-index: 1;
    }

    .setup {
        border-bottom: 1px solid #d8d8d8;
    }

    .lab {
        border-bottom: 1px solid #d8d8d8;
        background: vt-color(base-text);
        color: #fff;
    }

    .lab .setup-icon {
        font-size: 18px;
    }

    .menu-main-title h4 {
        font-size: 1rem;
    }

    .menu-main-title small {
        font-size: 0.7rem;
        text-transform: uppercase;
    }

    .menu-main-title {
        line-height: 0.9rem;
    }

    .menu-module {
        display: flex;
        border-bottom: 1px solid #d8d8d8;
        align-items: center;
        border-left: 1rem solid vt-color(primary);
        height: 48px;
    }

    .section-pd {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        width: 100%;
        margin: 0;
    }

    .icon-wrapper-main {
        font-size: 1.25rem;
    }

    .sidebar-tracking .branding {
        background: linear-gradient(to right, vt-color(primary), #76a1ff);
    }

    .sidebar-tracking .branding img {
        width: 70%;
    }

    /*--LAPTOP--*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {
        .sidebar-tracking {
            width: 268px;
        }
    }

    /*--Landscape--*/
    @media only screen and (min-device-width: 1281px) and (max-device-width: 2000px) {
        .sidebar-tracking {
            width: 268px;
        }
    }

    /*--Touch and 4:3--*/
    @media only screen and (min-device-width: 1080px) and (max-device-width: 1920px) {
        .sidebar-tracking {
            width: 300px;
        }
    }

</style>
